import React, { useEffect, useMemo, useState } from "react"
// import "./salesinvoice.scss"
import axios from "../axios"
import moment from "moment"
import numeral from "numeral"
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select"

import toastr from "toastr"
import "toastr/build/toastr.min.css";
// import "toastr/build/toastr.min.css";
import { makeStyles } from "@material-ui/core/styles"
import Spinner from "react-spinkit"
import Backdrop from "@material-ui/core/Backdrop"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
// import DeleteModal from "../../components/Common/DeleteModal"
// import SendMailConfirmation from "../../components/Common/SendMailConfirmation"
// import TableRows from "../../components/Common/TableRows"
// import TableContainer from "../../components/Common/TableContainer"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { saveAs } from "file-saver"
import {
  Divider, Tooltip, TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableBody,
  TextField, InputAdornment
} from "@material-ui/core"
import { Button as CustomButton2 ,Dialog, LinearProgress,} from "@mui/material"
import { styled } from "@mui/system"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import PrintIcon from "@mui/icons-material/Print";
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import MailIcon from "@mui/icons-material/Mail";
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  CardTitle,
  ModalHeader,
  ModalBody,
  Form,
  Card,
  Input,
  Container,
  Table,
  FormFeedback,
  Label,
  CardBody,
  Button,
} from "reactstrap"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialogpaper: {
    width: "1200px",
  },
}))




const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})

function Quotation() {
  const theme = useTheme()
  const matchesScreen = useMediaQuery(theme.breakpoints.up("md"))
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [quotationcollection, setquotationcollection] = useState([])
  const history = useHistory()
  const [deleteModal, setDeleteModal] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [deletepopup, setdeletepopup] = useState(false)
  const [dailoa1, setdailoa1] = useState(false)
  const [allCustomerData, setallCustomerData] = useState([])
  const [fromdate, setfromdate] = useState(new Date())
  const [todate, settodate] = useState(new Date())
  const [customerValue, setcustomerValue] = useState({
    label: "All Customer",
    value: 0,
  })
  const [nodataerror, setnodataerror] = useState(false)
  const classes = useStyles()
  const [confirmationModal, setConfirmationModal] = useState(false)


  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const [branchid, setbranchid] = useState("")

  const [deletedconfirm, setdeletedconfirm] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);




  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return quotationcollection.slice(
      page * rowsperpage,
      (page + 1) * rowsperpage,
    );
  };

  useEffect(() => {
    var date = new Date()
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastday = new Date(
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    )
    setfromdate(moment(firstday).format("YYYY-MM-DD"))
    settodate(moment(lastday).format("YYYY-MM-DD"))
    Getallcustomer()
    GetAllQuotationData1()
  }, [])

  const GetAllQuotationData1 = async () => {
    var date = new Date()
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastday = new Date(
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    )
    setdailoa1(true)
    const get = await axios.instance
      .get(
        `/Getallquotation/${sessionStorage.getItem(
          "Companyid"
        )}/${sessionStorage.getItem("Branch_Log")}/${customerValue.value}/${moment(firstday).format(
          "YYYYMMDD"
        )}/${moment(lastday).format("YYYYMMDD")}`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        if (res.data.length !== 0) {
          setquotationcollection(res.data)
        } else {
          //setnodataerror(true)
          setquotationcollection([])
        }
      })
    setTimeout(() => {
      setdailoa1(false)
    }, 1000)
  }

  const GetAllQuotationData = async () => {
    setdailoa1(true)
    const get = await axios.instance
      .get(
        `/Getallquotation/${sessionStorage.getItem(
          "Companyid"
        )}/${sessionStorage.getItem("Branch_Log")}/${customerValue.value}/${moment(fromdate).format(
          "YYYYMMDD"
        )}/${moment(todate).format("YYYYMMDD")}`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        if (res.data.length !== 0) {
          setquotationcollection(res.data)
        } else {
          //setnodataerror(true)
          setquotationcollection([])
        }
      })
    setTimeout(() => {
      setdailoa1(false)
    }, 1000)
  }

  const Getallcustomer = async () => {
    const get = await axios.instance
      .get(`/Getallcustomer/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Customer_Name,
          value: b.Customer_Id,
        }))
        options.push({ label: "All Customer", value: 0 })
        setallCustomerData(options)
      })
  }

  const SendNotificationInMail = async (id,id1) => {
    setOpenLoader(true);
    const token = sessionStorage.getItem('authtoken');

    const response = await axios.instance.get(
      `/GetQuotationPrint/${id}/${sessionStorage.getItem("Branch_Log")}/${sessionStorage.getItem("Companyid")}/N`,
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });
    const requestData = {
      // PO_id: id,
      scenario: 'Quotation_Processed_Mail',
      Customer_Log: id1,
      // Customer_Name: id1,
      Company_Name: sessionStorage.getItem('companyName'),
      Company_id: sessionStorage.getItem('Companyid'),
      quotation_id: id,
    };

    try {
      await axios.instance
        .post(`SendNotificationInMail`, requestData, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          console.log(res.data);
          if (res.data === 'Email sent successfully') {
            setOpenLoader(false);
            // setNotficationSent(true);
            toastr.success("Mail Sent Successfully");
          } else {
            setOpenLoader(false);
          }
        });
    } catch (error) {
      console.error('Failed to add email', error);
      setOpenLoader(false);
    } finally {
      setOpenLoader(false);
    }
  };

  const editquotation = col => {
    //console.log(col)
    // sessionStorage.setItem("quotation", col)
    sessionStorage.setItem("quotationid", col.quotation_id)
    history.push(`/QuotationEdit/${col.quotation_id}`)
  }

  const toggledeletemodal = id => {
    setDeleteModal(true)
    setdeletid(id)
  }

  const Deletequotation = async () => {
    const get1 = await axios.instance
      .delete(`/Deletequotation/${deletid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        //console.log(res.data)
        setDeleteModal(false)
        setdeletepopup(true)
        GetAllQuotationData()
      })
  }


  // const GetQuotationPrint = async id => {
  //   //console.log(id)
  //   const InvoicePrint = await axios.instance
  //     .get(
  //       `/GetQuotationPrint/${id}/${sessionStorage.getItem(
  //         "Branch_Log"
  //       )}/${sessionStorage.getItem("Companyid")}/N`,
  //       {
  //         headers: {
  //           Authorization: tokent,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then(() =>
  //               // axios.instance.get('/Purchaseorder', { responseType: 'blob' }),
  //               axios.instance.get('/GetQuotation', { responseType: 'blob' }),
  //             )
  //     .then(res => {
  //        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
  //                 // saveAs(pdfBlob, `Purchaseorder-${id2}.pdf`);
  //                 saveAs(pdfBlob, `Quotation.pdf`);
  //     }
  //     )

  // }

  const GetQuotationPrint = async id => {
    try {
      // Step 1: Fetch the Invoice Print
      const invoiceResponse = await axios.instance.get(
        `/GetQuotationPrint/${id}/${sessionStorage.getItem("Branch_Log")}/${sessionStorage.getItem("Companyid")}/N`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      );

      // Optional: Validate response if needed
      if (!invoiceResponse || invoiceResponse.status !== 200) {
        throw new Error("Failed to fetch invoice details");
      }

      // Step 2: Fetch the PDF Blob
      const pdfResponse = await axios.instance.get('/GetQuotation', { responseType: 'blob' });

      // Check for valid PDF response
      if (!pdfResponse || pdfResponse.status !== 200) {
        throw new Error("Failed to fetch PDF blob");
      }

      // Step 3: Create Blob and Save PDF
      const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
      saveAs(pdfBlob, `Quotation.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error.message);
      alert("Failed to generate PDF. Please try again.");
    }
  };


  const mailQuotation = async () => {
    const companyId = sessionStorage.getItem('Companyid');
    const userId = sessionStorage.getItem('UserId');
    try {
      const res = await axios.instance.post(
        `/SendMailQuotation`,
        {
          companyId,
          userId,
          QuotationId: deletid,
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      );
      if (res.data === 'Mails sent successfully') {
        toastr.success("Mail Sent Successfully");
        setConfirmationModal(false)
      }
    } catch (error) {
      toastr.error("Failed to send mail");
      console.error("Error sending mail:", error);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: "Quotation No",
        accessor: "quotation_no",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Quotation Date",
        accessor: "quotation_date",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Created By",
        accessor: "User_Name",
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Total",
        accessor: cellprops => numeral(cellprops.NetAmount).format("0,0.00"),
        filterable: false,
        disableFilters: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Link
                to="#"
                className="text-primary"
                onClick={() => {
                  const po = cellProps.row.original
                  editquotation(po)
                }}
              >
                <i
                  className="uil uil-pen font-size-18"
                  id="edittooltip21"
                  style={{ color: "blue" }}
                />
                <UncontrolledTooltip placement="top" target="edittooltip21">
                  Edit
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  // if (JSON.parse(sessionStorage.getItem("MenuItemQuotationControls")).Print == "Y") {
                  //   const po = cellProps.row.original
                  // GetQuotationPrint(po.quotation_id)
                  // sessionStorage.setItem("quotation", po)
                  // sessionStorage.setItem("quotationid", po.quotation_id)
                  // history.push(`/QuotationEdit/${po.quotation_id}/P`)
                  // } else {
                  //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                  // }
                }}
              >
                <i
                  className="uil uil-print font-size-18"
                  id="deletetooltip4"
                  style={{ color: "black" }}
                />
                <UncontrolledTooltip placement="top" target="deletetooltip4">
                  Print
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  if (JSON.parse(sessionStorage.getItem("MenuItemQuotationControls")).Print == "Y") {
                    const po = cellProps.row.original
                    setConfirmationModal(true)
                    GetQuotationPrint(po.quotation_id)
                    setdeletid(po.quotation_id)
                  } else {
                    toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                  }
                }}
              >
                <i className="uil uil-envelope-upload font-size-18"
                  id="deletetooltip5"
                  style={{ color: "blue" }}></i>
                <UncontrolledTooltip placement="top" target="deletetooltip5">
                  Mail
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  if (JSON.parse(sessionStorage.getItem("MenuItemQuotationControls")).Del == "Y") {
                    const po = cellProps.row.original
                    toggledeletemodal(po.quotation_id)
                  } else {
                    toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                  }

                }}
              >
                <i
                  className="uil uil-trash-alt font-size-18"
                  id="deletetooltip3"
                />
                <UncontrolledTooltip placement="top" target="deletetooltip3">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => Deletequotation()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}

      {/* <SendMailConfirmation
        show={confirmationModal}
        onDeleteClick={() => mailQuotation()}
        onCloseClick={() => setConfirmationModal(false)}
      /> */}

      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          <Row>
            <Col xs="12">
              <h6 className="titleviewinspections">Quotation</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs title="Sales" breadcrumbItem="Quotation" /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />
                  <Row
                    style={{ justifyContent: "center" }}
                    className="mt-2 mb-2"
                  >
                    <Col lg="5">
                      <div className="mb-3">
                        <Label htmlFor="manufacturerbrand">
                          <b>Customer Name </b>
                        </Label>
                        <Select
                          options={allCustomerData}
                          classNamePrefix="select2-search-disable"
                          value={customerValue}
                          onChange={value => {
                            setcustomerValue(value)
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label htmlFor="manufacturerbrand">
                          <b> From Date </b>
                        </Label>
                        <Input
                          type="date"
                          value={fromdate}
                          min={"1000-01-01"}
                          max={"9999-12-31"}
                          onChange={e => {

                            if (e.target.value) {
                              setfromdate(e.target.value)
                            } else {
                              // toastr.error("Invalid Date")
                            }

                          }}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label htmlFor="manufacturerbrand">
                          <b> To Date </b>
                        </Label>
                        <Input
                          type="date"
                          value={todate}
                          min={"1000-01-01"}
                          max={"9999-12-31"}
                          onChange={e => {
                            // console.log(e.target.value, 'hanok')
                            if (e.target.value) {
                              settodate(e.target.value)
                            } else {
                              // toastr.error("Invalid Date")
                            }
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg="1">
                      <div
                        className="mb-3 w-100 d-flex justify-content-center "
                        style={{ marginTop: matchesScreen ? "28px" : "0" }}
                      >
                        <button
                          type="submit"
                          className={`btn btn-primary ${matchesScreen
                            }`}
                          style={{ backgroundColor: "#3468C0", color: "white" }}
                          onClick={e => {
                            // e.preventDefault()
                            GetAllQuotationData()
                          }}
                        >
                          View
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-end mt-3">
                    <CustomButton2
                      variant="outlined"
                      color="primary"
                      style={{ backgroundColor: "#007bff", color: "white", borderColor: "#007bff",margin:'5px',padding:'5px' }}
                      onClick={() => {
                        // if (JSON.parse(sessionStorage.getItem("MenuItemQuotationControls")).New == "Y") {
                        history.push("/QuotationAdd")
                        // } else {
                        //   toastr.warning('Please Contact Admin', 'Operation Not Allowed')
                        // }

                      }}
                      size="small"
                    >
                      Add Quotation
                    </CustomButton2>
                  </div>
                  {/* <TableContainer
                    columns={columns}
                    data={quotationcollection}
                    isGlobalFilter={true}
                    isAddOrder={true}
                    isAddTableWithoutBorderStrap={true}
                  /> */}
                  <div>
                    <div className="Tabelinspections">
                      <TableContainer>
                        <Table className="InspectionTbls">
                          <TableHead>
                            <TableRow>
                              <TableCell>Quotation NO  </TableCell>
                              <TableCell align="left">Quotation Date</TableCell>
                              <TableCell align="left">Customer Name </TableCell>
                              <TableCell align="left">Created BY</TableCell>
                              <TableCell align="left">Total</TableCell>
                              <TableCell>Edit</TableCell>

                              <TableCell>Delete</TableCell>
                              <TableCell>Print</TableCell>
                              <TableCell>Mail</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {quotationcollection.length != 0 ? (
                              changepage().map(data => (
                                <TableRow key={data.Order_Id}>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.quotation_no}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.quotation_date}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "left" }}>
                                    {data.customer_name}
                                  </TableCell>


                                  <TableCell style={{ textAlign: "left" }}>
                                    {data.User_Name}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "right" }}>
                                    {data.NetAmount}
                                  </TableCell>
                                  <TableCell align="left">
                                    <IconButton size="small">
                                      {/* <VisibilityIcon fontSize="small"  */}
                                      <EditIcon
                                        fontSize="small"
                                        color="primary"
                                        onClick={() => {
                                          // editdata(data);
                                          console.log(data);
                                          // setdeleteid(data.Termsid);
                                          // setisedit(true);
                                          editquotation(data)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>


                                  <TableCell align="left">
                                    <IconButton size="small">
                                      <DeleteIcon
                                        color="error"
                                        fontSize="small"
                                        onClick={() => {
                                          // setdeletedconfirm(true);
                                          // setdeleteid(data.Termsid);
                                          setdeletedconfirm(true);
                                          // toggledeletemodal(data.branch_id)
                                          setdeletid(data.quotation_id)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell align="left">
                                    <IconButton size="small">
                                      <PrintIcon
                                        color="primary"
                                        fontSize="small"
                                        onClick={() => {
                                          // setPrintPerview(true);
                                          // window.scrollTo({
                                          //   top: 0,
                                          //   behavior: "smooth", // Smooth scrolling behavior
                                          // });
                                          GetQuotationPrint(data.quotation_id)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell align="left">
                                    <IconButton size="small">
                                      <MailIcon
                                        color="primary"
                                        fontSize="small"
                                        onClick={() => {
                                          // Add your mail-related function here
                                          // SendQuotationByEmail(data.quotation_id);
                                          SendNotificationInMail(data.quotation_id,data.customer_id);
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableCell align="left">NO Data Found</TableCell>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        component="div"
                        rowsPerPageOptions={pages}
                        count={quotationcollection.length}
                        rowsPerPage={rowsperpage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Backdrop open={dailoa1} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>

      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {deletepopup ? (
        <SweetAlert
          title="Quotation Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setdeletepopup(false)
          }}
        ></SweetAlert>
      ) : null}

      {nodataerror ? (
        <SweetAlert
          title="No Data Found"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setnodataerror(false)
          }}
        ></SweetAlert>
      ) : null}

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            Deletequotation();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

export default Quotation
